import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useGTMPageView() {
  const location = useLocation();

  useEffect(() => {
    const w = window as typeof window & { dataLayer?: Record<string, any>[] };

    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);
}
